export const virtualScroller = {
  background: "#ffffff",

  "& > div.MuiDataGrid-virtualScrollerContent": {
    display: "flex !important",
    height: "fit-content !important",
  },

  "& > div.MuiDataGrid-virtualScrollerContent > div.MuiDataGrid-virtualScrollerRenderZone": {
    position: "relative !important",
  },
}
